// extracted by mini-css-extract-plugin
export default {"borderBrownGrey":"style-module--borderBrownGrey--x3FAu"};